import script from "./my-price.vue?vue&type=script&setup=true&lang=js"
export * from "./my-price.vue?vue&type=script&setup=true&lang=js"

import "./my-price.vue?vue&type=style&index=0&id=8f7f490c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f7f490c"]])

export default __exports__